// features/context/index.js
import React from 'react';

export const ClickContext = React.createContext();

// Kept in sync with the mobile breakpoint used across the layout
// (Sidebar/Header). Desktop-only state (sidebarOpen/outletMarginLeft)
// is untouched by anything below.
const MOBILE_BREAKPOINT = 768;

export class ClickProvider extends React.Component {
    state = {
        // Expanded sidebar width (the sidebar renders at this minus 10px).
        // Was 290 — narrowed for a tighter, more standard nav width.
        outletMarginLeft: "240",
        sidebarOpen: true,
        // Mobile-only: whether the off-canvas sidebar drawer is open, and
        // whether we're currently at a mobile viewport width.
        isMobile: typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT,
        isSidebarMobileOpen: false,
        updateMarginLeft: (size) => this.setState({ outletMarginLeft: size }),
        toggleSidebar: () => this.setState(prevState => ({
            sidebarOpen: !prevState.sidebarOpen,
            outletMarginLeft: !prevState.sidebarOpen ? "240" : "80"
        })),
        openMobileSidebar: () => this.setState({ isSidebarMobileOpen: true }),
        closeMobileSidebar: () => this.setState({ isSidebarMobileOpen: false }),
        toggleMobileSidebar: () => this.setState(prevState => ({
            isSidebarMobileOpen: !prevState.isSidebarMobileOpen
        })),
        TENANT_CONFIGS: [],
    };

    handleResize = () => {
        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
        if (isMobile !== this.state.isMobile) {
            // Leaving mobile width always closes the drawer so it can't get
            // stuck open when the desktop (pushed) layout takes back over.
            this.setState({
                isMobile,
                isSidebarMobileOpen: isMobile ? this.state.isSidebarMobileOpen : false
            });
        }
    };

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.handleResize);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.handleResize);
        }
    }

    render() {
        return (
            <ClickContext.Provider value={this.state}>
                {this.props.children}
            </ClickContext.Provider>
        );
    }
}